module.exports = new __parcel__URL__("integration-puzzle.9fe08f02.svg").toString();